import React, { useEffect, useState } from "react";
import styles from "./NFTlist.module.sass";
import cn from "classnames";
import Loader from "../../Loader";
import Row from "./row";
import NFTModal from "../../NFTModal";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import Empthy from "../../Empty";
import { UseApi } from "../../../hooks/use-api";
import { GetNFTsAdmin } from "../../../Services/lib/nft";

const NFTList = ({ ProductId }) => {
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [nft, setNFT] = useState();

	const [{ isLoading }, getNFTs_] = UseApi({
		service: GetNFTsAdmin,
	});
	const [a, setA] = useState(0);

	const [NFTs, setNFTs] = useState();
	const [total, setTotal] = useState(0);

	const fetch = async () => {
		const res = await getNFTs_({
			limit: 25,
			offset: a + 1,
			nftTemplateId: ProductId,
			sortBy: "createdAt",
			orderBy: "asc",
		});
		if (res) {
			console.log(res.nfts);
			setNFTs(res.nfts);
			setTotal(res.count);
		}
	};

	useEffect(() => {
		if (a !== 0) fetch();
	}, [a]);

	useEffect(() => {
		fetch();
		setTotal(0);
		setA(0);
	}, [ProductId]);

	const close = () => {
		setNFT();
		onClose();
	};

	const open = (data_) => {
		setNFT(data_);
		onOpen();
	};
	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.table}>
					<div className={styles.row}>
						<div className={styles.col}>NFT</div>
						<div className={styles.col}>Owner</div>
						<div className={styles.mail}>Email</div>
						<div className={styles.col}>Status</div>
						<div className={styles.col}>Price</div>
						{NFTs?.length > 0 && NFTs[0].tokenType === "EXPERIENCE_TOKEN" ? (
							<div className={styles.col}>Status</div>
						) : null}
					</div>
					{!isLoading ? (
						NFTs?.length === 0 ? (
							<Empthy title="NFT list will appear after mint proccess end" />
						) : (
							NFTs?.map((e) => {
								return <Row open={open} key={e._id} item={e} />;
							})
						)
					) : (
						<div className={styles.loaderWrap}>
							<Loader />
						</div>
					)}
				</div>
				<div className={styles.foot}>
					{NFTs?.length < total && (
						<button
							onClick={() => setA((p) => p + 1)}
							className={cn("button-stroke button-small", styles.button, {
								disabled: isLoading,
							})}
						>
							{isLoading && <Loader className={styles.loader} />}
							<span>Load more</span>
						</button>
					)}
				</div>
			</div>
			<NFTModal visible={isOpen && nft} onClose={close} data={nft} />
		</>
	);
};

export default NFTList;
